import { render, staticRenderFns } from "./FlexBox.vue?vue&type=template&id=620037ce&"
import script from "./FlexBox.vue?vue&type=script&lang=js&"
export * from "./FlexBox.vue?vue&type=script&lang=js&"
import style0 from "./FlexBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports